/**
 * Program: Austria
 * Language: German
 * Content: Terms & Conditions
 */

// eslint-disable-next-line import/prefer-default-export
const terms = `
# Allgemeine Geschäftsbedingungen für den Dyson Trade-In-Service

Diese Geschäftsbedingungen regeln den Dyson Trade-In-Service, der von Alchemy Telco Solutions Limited, Monasterevin Road, Kildare, Ireland, R51A262 („Anbieter“, „uns“, „unser“ oder „wir“) bereitgestellt wird ") für und im Namen von Dyson Deutschland („Dyson“).

Wenn Du den Trade-In-Service mit uns abschließt, kannst Du (der „Kunde“) einen Prämienbetrag erhalten, wenn Du während des Angebotszeitraums ein bestimmtes neues Dyson-Gerät bei einem teilnehmenden Einzelhändler kaufst und einen berechtigten Staubsauger oder ein Beauty-Gerät, während des Trade-In-Zeitraums beim Verkäufer in Zahlung gibst, wie unten näher beschrieben.

1. ### Wer kann den Trade-In-Service in Anspruch nehmen? Ausnahmen

    Du musst mindestens achtzehn (18) Jahre alt sein. Die Inanspruchnahme des Trade-In-Service steht Wiederverkäufern von Dyson-Produkten nicht offen und ist nicht für Käufe möglich, die über Dyson-Mitarbeitercodes getätigt werden.

2. ### So schließt Du den Trade-In-Service ab
    Um den Trade-In-Service in Anspruch zu nehmen, musst Du Folgendes tun und die folgenden Voraussetzungen erfüllen:

    1. Du musst einen neuen Dyson-Staubsauger oder ein neues Dyson-Beauty-Gerät der folgenden Modelle gekauft haben:
        - V15s Detect Submarine™
        - Gen5detect™ Absolute
        - V16 Piston Animal
        - V16 Piston Animal Submarine™
        - V16 Piston Animal + Detailed Cleaning Kit
        - V16 Piston Animal Submarine™ (Soft Bundle)
        - Airwrap Co-anda2x™
        - Airwrap i.d.™ (ausgewählte Modelle)

        (jeweils ein „**Neues Dyson-Gerät** “).

    2. Der Kauf des neuen Dyson-Geräts muss zwischen dem 15. September 2025 und dem 31. Oktober 2025 (jeweils einschließlich) („**Angebotszeitraum**“) erfolgt sein. Du darfst dein neues Dyson-Gerät während der zulässigen Rückgabefrist nach dem Kauf nicht gegen eine Rückerstattung zurückgegeben haben.

    3. Der Kauf des neuen Dyson-Geräts muss bei einem der folgenden Einzelhändler erfolgt sein, entweder online oder in einem physischen Geschäft in Deutschland:

        - Dyson Demo Stores an folgenden Standorten:
            - Dyson Store – Mönckebergstraße, Hamburg
            - Dyson Store – Westfield Centro, Oberhausen
            - Dyson Store - Tauentzienstraße, Berlin
            - Dyson Store – Hohe Straße, Köln
            - Dyson Store - MyZeil, Frankfurt am Main
            - Dyson Store – Olympia Einkaufszentrum
        - Dyson.de Website
        - Einzelhändler:
            - Mediamarkt & Saturn
            - Breuninger
            - Expert
            - Euronics
            - Flaconi
            - Metro
            - QVC
            - KaDeWe
            - Otto

    4. Nach dem Kauf musst Du innerhalb des Angebotszeitraums ein Registrierungsformular unter [Weblink zu Dyson.de erforderlich] ausfüllen und die folgenden Angaben machen:

        - Name und Postanschrift, E-Mail-Adresse und Telefonnummer
        - Bankkontodaten einer Bank in Deutschland oder einem anderen Land innerhalb des Europäischen Wirtschaftsraums, an die ggf. Zahlungen erfolgen können.

        Darüber hinaus musst Du eine Kopie des Kaufbelegs des neuen Dyson-Geräts, ein Foto der Seriennummer des ausgepackten neuen Dyson-Geräts hochladen und Angaben zum berechtigten Trade-In-Gerät (wie unten definiert) machen. Du kannst dich für den Trade-In-Service nur einmal für ein bestimmtes neues Dyson-Gerät anmelden.

    5. Nach dem Ausfüllen des Registrierungsformulars erhältst Du ein vorfrankiertes Frachtetikett, mit dem Du dein Gerät zur Inzahlungsnahme an uns senden kannst. Du kannst nur alte Staubsauger in Zahlung geben, um eine Rückerstattung für einen neuen Dyson Staubsauger zu erhalten und alte Beauty-Geräte nur für ein neues Dyson-Beauty-Gerät. Bei dem eingetauschten Gerät kann es sich um jedes vergleichbare Gerät handeln, unabhängig von Marke und Modell. Wenn Du einen Staubsauger eintauschst, muss dies intakt sein (in einem Stück, darf nicht zerbrochen sein) und der Staubsammelbehälter oder -beutel muss leer sein **(„Zugelassene Eintauschgebühr“/ Gerät"**). Saugstäbe, Schläuche, Kabel, Batterien oder anderes Zubehör sind nicht erforderlich.

    6. Anschließend musst Du dein berechtigtes Inzahlungsnahmegerät innerhalb von 14 Kalendertagen nach Erhalt des vorfrankierten Frachtetiketts **(„Inzahlungsnahmefrist“)** an uns senden, indem Du es bei einer DHL-Sammelstelle in Deutschland abgibst. Die Frachtkosten gehen zu Lasten des Verkäufers und beziehen sich nur auf dieses bestimmte berechtigte Eintauschgerät.

    7. Berechtigte Eintauschgeräte können bis zu 4 Wochen nach dem letzten Datum des Aktionsangebots versendet werden.

3. ### Prämienbetrag für berechtigtes Eintauschgerät
    Sobald wir den Erhalt des berechtigten Eintauschgeräts zusammen mit den erforderlichen Angaben aus dem Registrierungsformular bestätigt haben, zahlen wir an dich:

    - V15s Detect Submarine™: 200 €
    - Gen5detect™ Absolute: 200 €
    - V16 Piston Animal: 150 €
    - V16 Piston Animal Submarine™: 150 €
    - V16 Piston Animal + Detailed Cleaning Kit: 150 €
    - V16 Piston Animal Submarine™ (Soft Bundle): 150 €
    - Airwrap Co-anda2x™, Airwrap i.d.™ (ausgewählte Modelle): 100 € ( Bei einem eingetauschten Dyson Beauty-Gerät), 75 € (Bei einem eingetauschten Beauty-Gerät einer anderen Marke)

    Du erhältst eine Bestätigung über den jeweiligen Prämienbetrag an die uns mitgeteilte E-Mail-Adresse. Wir veranlassen die Zahlung frühestens 30 Tage und in jedem Fall innerhalb von 45 Tagen nach Erhalt eines gültigen berechtigten Eintauschgeräts. Alle Angebote und Zahlungen verstehen sich inklusive Mehrwertsteuer (sofern zutreffend).

    Die Auszahlung erfolgt per Banküberweisung auf die von Dir angegebene Bankverbindung. Du bist dafür verantwortlich, uns korrekte Bankdaten mitzuteilen, und wir haften nicht für den Fall, dass falsche Bankdaten angegeben wurden.

    Für den Fall, dass das eingetauschte Gerät nicht berechtigt ist (z. B. kein Staubsauger oder Beauty-Gerät), erfolgt keine Zahlung und wir werden Dich kontaktieren, damit Du die Rücksendung des Artikels veranlassen kannst, falls Du den Artikel zurückerhalten möchtest. Sämtliche Rücksendekosten gehen zu deinen Lasten.

4. ### Eigentumsübertragung auf den Verkäufer

    Nach Erhalt und Annahme des berechtigten Trade-In-Geräts geht das Eigentumsrecht an diesem berechtigten Trade-In-Gerät vom Kunden auf den Anbieter über und der Kunde lehnt alle weiteren Rechte, Titel oder Interessen an dem berechtigten Trade-In-Gerät oder anderen Gegenständen darin enthalten ab.

5. ### Kundenerklärungen

    Du erklärst, dass:

    - Du der alleinige Eigentümer des berechtigten Eintauschgeräts bist oder vom Eigentümer des berechtigten Eintauschgeräts autorisiert worden und dass du in der Lage bist, Entscheidungen in Bezug auf das berechtigte Eintauschgerät zu treffen.
    - Es gibt keine Pfandrechte, Belastungen oder Sicherungsrechte an dem berechtigten Eintauschgerät und dass keine andere Partei ein rechtliches Interesse daran hat.
    - Alle Artikel, die du über den Trade-In-Service recyceln möchtest, dürfen keine geistigen Eigentumsrechte Dritter verletzen (einschließlich Urheberrechte, Marken, Patente, Geschäftsgeheimnisse oder andere Eigentumsrechte).
    - Du bist kein Wiederverkäufer von Dyson-Produkten und beabsichtigst auch nicht, dies zu tun.
    - Das berechtigte Eintauschgerät ist nicht gefälscht, gestohlen oder betrügerisch.

6. ### Haftungsbeschränkung

    Die Haftung des Verkäufers für die Verletzung vertraglicher und außervertraglicher Pflichten bestimmt sich nach den einschlägigen gesetzlichen Vorschriften.

    Auf Schadensersatz haftet der Verkäufer – gleich aus welchem Rechtsgrund – nur bei Vorsatz und grober Fahrlässigkeit. Im Falle einfacher Fahrlässigkeit haftet der Verkäufer nur

     1. für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.

     2. für Schäden aus der Verletzung einer wesentlichen Vertragspflicht; in diesem Fall ist jedoch die Schadensersatzhaftung des Verkäufers auf den vorhersehbaren, typischerweise eintretenden Schaden begrenzt. Als wesentliche Vertragspflicht gilt in diesem Sinne eine Pflicht, ohne deren Einhaltung die ordnungsgemäße Durchführung des Vertrages überhaupt nicht möglich ist und auf deren Einhaltung die andere Partei vertraut und vertrauen darf.

    Alle weiteren Ansprüche des Kunden aus Vertrag oder unerlaubter Handlung sind ausgeschlossen.

7. ### Online-Streitbeilegung

    Die Europäische Kommission stellt eine Plattform für die außergerichtliche Online-Streitbeilegung (OS-Plattform) bereit, aufrufbar unter <https://ec.europa.eu/consumers/odr>. Zur Teilnahme an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht bereit.

8. ### Kommunikation zwischen uns

    Du kannst das Kundendienstteam des Anbieters unter der E-Mail-Adresse <dyson@wearealchemy.com> kontaktieren. Wenn wir Dich kontaktieren oder Dir eine schriftliche Mitteilung zukommen lassen müssen, werden wir dies per E-Mail an die Adresse tun, die Du uns in deinem ausgefüllten Formular angegeben hast.

9. ### Datenschutz

    Bezüglich der Verwendung deiner persönlichen Daten durch Alchemy gelten die folgenden Datenschutzinformationen:

    **Datenschutzinformationen für den Dyson Trade-In-Service**

    Alchemy nimmt den Schutz deiner Privatsphäre sehr ernst. Bitte lese Dir diese Datenschutzinformationen sorgfältig durch, da sie wichtige Informationen darüber enthalten, wer wir sind und wie und warum wir deine personenbezogenen Daten erfassen, speichern, verwenden und weitergeben. Darüber hinaus erläutern wir Dir deine Rechte in Bezug auf deine personenbezogenen Daten und wie Du im Falle einer Beschwerde Kontakt zu uns oder den Aufsichtsbehörden aufnehmen kannst.

    Wir erheben, verarbeiten und sind für bestimmte personenbezogene Daten über Dich verantwortlich. Wenn wir dies tun, unterliegen wir den geltenden Datenschutzgesetzen und sind als Datenverantwortlicher für diese personenbezogenen Daten im Sinne dieser Gesetze verantwortlich.

    1. **Wer ist der Verantwortliche für personenbezogene Daten/Kontaktdaten?**

        Verantwortlicher im Sinne der datenschutzrechtlichen Bestimmungen ist

        Alchemy Telco Solutions Ltd.
        Monasterevin Road
        Kildare, Ireland, R51A262

        (im Folgenden „wir“ oder „uns“).

        [privacy@alchemyglobalsolutions.com](mailto:privacy@wearealchemy.com) an unseren Datenschutzbeauftragten wenden.

    2. **Welche personenbezogenen Daten wir verarbeiten**

        Wir erheben und verarbeiten die folgenden personenbezogenen Daten über Dich, wenn Du deine Daten über den Dyson Trade-In-Service übermittelst:

        - Dein Name und deine Kontaktinformationen, einschließlich Postanschrift, E-Mail-Adresse und Telefonnummer,
        - Deine Rechnungsinformationen, Transaktions- und Zahlungsinformationen (einschließlich Bankkontoinformationen),
        - Informationen zu deinem neuen Dyson-Gerät und dem jeweiligen Kauf (Bilder des ausgepackten Kaufbelegs und des neuen Dyson-Geräts und seiner Seriennummer),
        - Informationen zu deinem Trade-In-Gerät (einschließlich einer Seriennummer, falls es sich bei dem Trade-In-Gerät um ein Dyson-Gerät handelt)

    3. **Zu welchem Zweck verarbeiten wir deine personenbezogenen Daten?**

        Deine Kontakt- und Rechnungsinformationen sowie die Informationen zu deinem neuen Dyson-Gerät und deinem berechtigten Trade-In-Gerät werden von uns ausschließlich zur Bereitstellung des Trade-In-Service für und im Namen der Dyson Firma in ÖstDeutschlanderreich, um dich im Rahmen des Trade-In-Service -Service zu kontaktieren und Zahlungen an dich für dein berechtigtes Trade-In-Gerät durchzuführen.

    4. **Mit wem teilen wir deine Daten?**

        Wir geben die Seriennummer des neuen Dyson-Geräts sowie die Seriennummer eines Trade-In-Gerät, bei dem es sich um ein Dyson-Gerät handelt, an Dyson weiter. Dyson wird diese Informationen für eigene Zwecke verarbeiten (einschließlich der Ausmusterung eines Dyson-Trade-In-Geräts des zukünftigen Supportes).

        Zur technischen Bereitstellung des Trade-In-Services nutzen wir professionelle Auftragsverarbeiter, die für uns bestimmte Leistungen wie Hosting- und Softwaredienstleistungen erbringen. Alle Auftragsverarbeiter sind an vertragliche Maßnahmen entsprechend den gesetzlichen Vorgaben gebunden.

        Bei der Weitergabe von Daten an Empfänger außerhalb der EU beachten wir die gesetzlichen Vorgaben, um beim Empfänger ein angemessenes Datenschutzniveau sicherzustellen. Zu den Maßnahmen gehört die Verwendung von Standardvertragsklauseln, die von der Europäischen Kommission herausgegeben wurden und von denen Du jederzeit eine Kopie bei uns anfordern kannst, indem Du uns kontaktierst.

    5. **Auf welcher Rechtsgrundlage verarbeiten wir deine personenbezogenen Daten?**

        Rechtsgrundlage für die gesamte Verarbeitung deiner personenbezogenen Daten im Rahmen des Trade-In-Service ist Art. 6 Abs. 1 lit. b DSGVO. Art. 6 Abs. 1 lit. b) und f) DSGVO. Unser berechtigtes Interesse ist unser Geschäftsinteresse, Dir den Trade-In-Service im Namen von Dyson anzubieten.

    6. **Aufbewahrung personenbezogener Daten**

        Im Rahmen des Dyson Trade-In-Service erfassten personenbezogenen Daten, wie in dieser Datenschutzerklärung beschrieben, so lange, wie Du unsere Dienste nutzen oder wie es zur Erfüllung des Zwecks des Trade-In-Service, einschließlich der Beilegung von Streitigkeiten, erforderlich ist. Um Rechtsverteidigungen aufzubauen, legitime Geschäftszwecke zu verfolgen, unsere Vereinbarungen durchzusetzen und geltende Gesetze und zwingende Aufbewahrungspflichten einzuhalten.

    7. **Welche gesetzlichen Rechte habe ich?**

        Vorbehaltlich der gesetzlichen Voraussetzungen hast Du das Recht, von uns unentgeltlich zu verlangen:

        - Auskunft über die zu deiner Person gespeicherten personenbezogenen Daten (Art. 15 DSGVO),
        - Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO)
        - Weitergabe deiner Daten an einen Dritten (Art. 20 DSGVO).

        Darüber hinaus hast Du jederzeit das uneingeschränkte Beschwerderecht bei einer zuständigen Datenschutzaufsichtsbehörde, dies kann die Aufsichtsbehörde Ihres gewöhnlichen Aufenthaltsortes sein (Art. 77 DSGVO).
`

export default terms
